export const CAD = 'CAD'
export const USD = 'USD'
